
import {useEffect, useState} from "react";
import {Flex, Typography, Button} from "antd";
import SignInUp from "../components/SignInUp";

function RouteSignUp(props) {


    useEffect(() => {

    }, []);


    return (
        <div className="view auth">
            <SignInUp type="SIGN_UP" isSignUp={true} onSignUpSuccess={props.onSignUpSuccess} text="signup_with"></SignInUp>
        </div>
    );
}

export default RouteSignUp;
